import React from 'react'
import SideBar from '../sidebar'

const Main = (props) => {
  return (
    <div className="main-viewport">
      <div className="main-viewport__side-nav">
        <SideBar />
      </div>
      <div className="main-viewport__children">{props.children}</div>
    </div>
  )
}

export default Main
